import { render, staticRenderFns } from "./WalletWithoutShopping.vue?vue&type=template&id=3dec13bb&"
import script from "./WalletWithoutShopping.vue?vue&type=script&lang=js&"
export * from "./WalletWithoutShopping.vue?vue&type=script&lang=js&"
import style0 from "./WalletWithoutShopping.vue?vue&type=style&index=0&id=3dec13bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports